var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoreServiceScoreDetail',{attrs:{"detailData":_vm.detailData}})
}
var staticRenderFns = []

export { render, staticRenderFns }